// Core Modules
import { ApplicationConfig, importProvidersFrom, provideZoneChangeDetection } from '@angular/core';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { provideRouter, TitleStrategy, withComponentInputBinding, withInMemoryScrolling } from '@angular/router';

// External Modules
import { CacheFactory } from 'cachefactory';
import Highcharts from 'highcharts';
import 'highcharts/modules/accessibility';
import 'highcharts/modules/exporting';
import 'highcharts/highcharts-more';
import 'highcharts/modules/stock';
import { NgxPermissionsModule } from 'ngx-permissions';
import * as Papa from 'papaparse';
import { provideHighcharts } from 'highcharts-angular';
import { provideUserIdleConfig } from 'angular-user-idle';

// Tokens
import { PAPA_PARSE, WINDOW } from '@core/injection-tokens/tokens';

// Interceptors
import { authInterceptor } from '@core/interceptors/auth.interceptor';

// Strategies
import { CustomTitleStrategy } from '@core/strategies/custom-title-strategies';

// Routes
import { routes } from '@app/app.routes';

// Environment
import { environment } from '@env/environment';

const highChartOptions: Highcharts.Options = {
  exporting: {
    enabled: false,
    showTable: true,
  },
  lang: {
    thousandsSep: ',',
  },
  chart: {
    style: {
      fontFamily: 'plusjakartasans',
    },
  },
  legend: {
    events: {
      itemClick: () => false,
    },
  },
};

export const appConfig: ApplicationConfig = {
  providers: [
    CacheFactory,
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(
      routes,
      withComponentInputBinding(),
      withInMemoryScrolling({
        scrollPositionRestoration: 'top',
      })
    ),
    provideHttpClient(withInterceptors([authInterceptor])),
    importProvidersFrom(NgxPermissionsModule.forRoot()),
    provideUserIdleConfig({
      idle: environment.SESSION.maxIdleWaitTime,
      timeout: environment.SESSION.logoutNotifyExpiryTime,
      ping: environment.SESSION.refreshSessionInterval,
    }),
    provideHighcharts({
      instance: () => Promise.resolve(Highcharts),
      options: highChartOptions,
    }),
    {
      provide: TitleStrategy,
      useClass: CustomTitleStrategy,
    },
    {
      provide: WINDOW,
      useValue: window,
    },
    {
      provide: PAPA_PARSE,
      useValue: Papa,
    },
  ],
};
